import type { TOC } from '@ember/component/template-only';
import { Illustration } from 'frontend-utils';

import styles from './skeleton.module.css';

interface HotelBenchmarkInsightSkeletonSignature {
  Args: {
    imageHtml: string;
    showAnimation?: boolean;
  };
}

const HotelBenchmarkInsightSkeleton = <template>
  <div
    class="{{styles.skeleton}}
      {{if @showAnimation styles.skeleton--with-animation}}"
  >
    <Illustration @html={{@imageHtml}} class={{styles.image}} />
  </div>
</template> satisfies TOC<HotelBenchmarkInsightSkeletonSignature>;

export default HotelBenchmarkInsightSkeleton;
